<script lang="ts">
  import { writable } from 'svelte/store';
  import { socketStatus } from '$lib/stores';
  import type { ConnectionStatus } from '$lib/WebSocket';

  const title = writable('No connectado');

  const titles: Record<ConnectionStatus, string> = {
    CLOSED: 'No conectado',
    CLOSING: 'No conectado',
    CONNECTING: 'Conectando',
    NOT_CONNECTED: 'No conectado',
    OPEN: 'Conectado'
  } as const;

  $: {
    title.set(titles[$socketStatus]);
  }
</script>

<div
  class="flex w-2.5 h-2.5 rounded-full"
  class:bg-orange-500={$socketStatus == 'CONNECTING'}
  class:bg-green-500={$socketStatus == 'OPEN'}
  class:bg-red-500={$socketStatus == 'CLOSING' ||
    $socketStatus == 'CLOSED' ||
    $socketStatus == 'NOT_CONNECTED'}
  title={$title}
></div>
